import React from "react";
import { createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper<any>();

export const getReviewDispatch = () => [
    columnHelper.accessor("carrierName", {
      header: "Carrier",
      size: 300,
        cell: info => info.getValue() ? <div>{`${info.getValue()} ${info.row.original.carrierNumber > 0 ? `(${info.row.original.carrierNumber})` : ''}`}</div> : '',
    }),

    columnHelper.accessor("laneCount", {
      header: "Lanes",
      size: 150,
      cell: info => info.getValue() != null ? <div>{info.getValue()}</div> : '-',
    }),

    columnHelper.accessor("dropCount", {
      header: "Drops",
      size: 130,
      cell: info => info.getValue() != null ? <div>{info.getValue()}</div> : '-',
    }),

  ];
